import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import SplashScreen from "./components/ordertracking/SplashScreen";
import TrackingPage from "./components/ordertracking/LiveTrackingMap";


const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* Default Route → Splash */}
        <Route path="/" element={<SplashScreen/>} />

        {/* Tracking with dynamic orderId */}
        <Route path="/track/:orderId" element={<TrackingPage/>} />

        {/* Catch-all → redirect to splash */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
